module.exports = __webpack_public_path__ + "static/media/join-us-img.2da101f3.png";